module.exports = __webpack_public_path__ + "img/news29-2.4945bf70.png";